var _mask, _mask2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFinanceStep03 = function SvgIconFinanceStep03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 120,
    width: 120,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-finance-step03_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.668.185h75.41V98.25H.669z",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-finance-step03_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 105.348h89.579V0H0z",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-534-156H906v789H-534z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.638.185H25.882a4.442 4.442 0 0 0-4.441 4.442v17.282a26.682 26.682 0 0 0-12.92 7.162c-10.47 10.471-10.471 27.448 0 37.919a26.661 26.661 0 0 0 12.92 7.163v19.655a4.442 4.442 0 0 0 4.441 4.442h45.756a4.441 4.441 0 0 0 4.441-4.442V4.627A4.441 4.441 0 0 0 71.638.185",
    fill: "#cfdde9",
    mask: "url(#icon-finance-step03_svg__a)",
    transform: "translate(28.5 14.598)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#051a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.899 82.594v19.655a4.44 4.44 0 0 0 4.44 4.44h45.756a4.441 4.441 0 0 0 4.441-4.44V13.067a4.442 4.442 0 0 0-4.441-4.442H41.339a4.44 4.44 0 0 0-4.44 4.441V30.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.76 29.9v-8.793h46.48V95.4H40.76V83.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.372 29.9c7.997-1.068 16.382 1.466 22.526 7.61 9.007 9.007 10.259 22.825 3.77 33.18l2.545 9.495a1.274 1.274 0 0 1-1.56 1.56L57.157 79.2c-5.38 3.372-11.695 4.649-17.785 3.839m-2.473-.445c.818.188 1.643.334 2.473.445m-2.473-52.69a26.685 26.685 0 0 0-12.921 7.161c-10.47 10.47-10.47 27.448 0 37.919a26.67 26.67 0 0 0 12.92 7.164M39.372 29.9c-.83.11-1.655.26-2.473.449m0 22.163a6.5 6.5 0 0 1 .898-.575c1.373-1.372.46-3.854.46-3.854l-1.097-4.14a4.915 4.915 0 0 0-.261-.845m0 22.402a31.723 31.723 0 0 0 2.473 1.978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.372 67.477c2.646 1.911 6.527 4.11 11.18 4.93 0 0 4.593-.013 6.189-2.524a6.019 6.019 0 0 0 1.902-3.936l.085-1.06s-.494-1.73-2.863-2.238l-4.14-1.097s-2.482-.915-3.855.458c0 0-1.7 3.4-3.597 1.634 0 0-1.512-.85-3.331-2.713-.518-.53-1.043-1.049-1.57-1.569M36.899 65.5c-.859-.763-1.325-1.267-1.325-1.267S28.97 58.15 27.4 49.255c0 0 .015-4.593 2.525-6.188a6.019 6.019 0 0 1 3.936-1.903l1.06-.085s1.301.374 1.979 2.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.372 59.362c-.166-.165-.328-.333-.496-.496a19.318 19.318 0 0 1-1.977-2.247m0-4.107c-.862.657-1.877 1.797-.735 3.021 0 0 .241.425.735 1.086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.56 9.368h18.802V5.783H39.56z",
    mask: "url(#icon-finance-step03_svg__b)",
    transform: "translate(15 7.5)"
  })))));
};
export default SvgIconFinanceStep03;